import {
  lazy,
  Suspense,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { LanguageContext } from "./context/LanguageContext";
import "./App.css";
import MediaPageLoader from "./components/MediaPageLoader/MediaPageLoader";
import { runPageMediaReadyWithCap } from "./utils/runAppBoot";

import Home from "./pages/Home/Home";
import ScrollToTopButton from "./components/ScrollToTopButton";
import ProtectedRoute from "./components/ProtectedRoute";
import VoyahCourageSpecifications from "./pages/VoyahCourageSpecifications/VoyahCourageSpecifications";
import VoyahFreeSpecifications from "./pages/VoyahFreeSpecifications/VoyahFreeSpecifications";
import CourageEditor from "./components/Dashboard/pages/CourageEditor";
import CourageSpecsEditor from "./components/Dashboard/pages/CourageSpecsEditor";
import CourageVideoTextEditor from "./components/Dashboard/pages/CourageVideoTextEditor";
import CourageSpecCardsEditor from "./components/Dashboard/pages/CourageSpecCardsEditor";
import VoyahCourageSpecSectionEditor from "./components/Dashboard/pages/VoyahCourageSpecSectionEditor";
import VoyahCourageSliderEditor from "./components/Dashboard/pages/VoyahCourageSliderEditor";
import VoyahCourageExpEditor from "./components/Dashboard/pages/VoyahCourageExpEditor";
import VoyahFreeHeroEditor from "./components/Dashboard/pages/VoyahFreeHeroEditor";
import VoyahFreeExploreEditor from "./components/Dashboard/pages/VoyahFreeExploreEditor";
import VoyahFreeFeelSecEditor from "./components/Dashboard/pages/VoyahFreeFeelSecEditor";
import VoyahFreeAdaptedEditor from "./components/Dashboard/pages/VoyahFreeAdaptedEditor";
import VoyahFreeGridEditor from "./components/Dashboard/pages/VoyahFreeGridEditor";
import VoyahStylishEditor from "./components/Dashboard/pages/VoyahStylishEditor";
import VoyahFreeTabsEditor from "./components/Dashboard/pages/VoyahFreeTabsEditor";
import VoyahFreeTrunkEditor from "./components/Dashboard/pages/VoyahFreeTrunkEditor";
import VoyahFreeGrid2Editor from "./components/Dashboard/pages/VoyahFreeGrid2Editor";
import VoyahFreeModsEditor from "./components/Dashboard/pages/VoyahFreeModsEditor";
import VoyahFreeMomentsEditor from "./components/Dashboard/pages/VoyahFreeMomentsEditor";
import VoyahFreeAssistEditor from "./components/Dashboard/pages/VoyahFreeAssistEditor";
import VoyahFreeAmbientEditor from "./components/Dashboard/pages/VoyahFreeAmbientEditor";
import VoyahCourageSpecificationEditor from "./components/Dashboard/pages/VoyahCourageSpecificationEditor";
import VoyahFreeSpecificationsEditor from "./components/Dashboard/pages/VoyahFreeSpecificationsEditor";
import BuildCourage from "./pages/BuildCourage/BuildCourage";
import VoyahDreamSpecifications from "./pages/VoyahDreamSpecifications/VoyahDreamSpecifications";
import BuildVoyahFree from "./pages/BuildVoyahFree/BuildVoyahFree";
import BuildVoyahDream from "./pages/BuildVoyahDream/BuildVoyahDream";
import VoyahDreamSpecificationsEditor from "./components/Dashboard/pages/VoyahDreamSpecificationsEditor";
import VoyahDreamHeroEditor from "./components/Dashboard/pages/VoyahDreamHeroEditor";
import VoyahDreamExpEditor from "./components/Dashboard/pages/VoyahDreamExpEditor";
import VoyahDreamLuxuryEditor from "./components/Dashboard/pages/VoyahDreamLuxuryEditor";
import VoyahDreamAdaptedEditor from "./components/Dashboard/pages/VoyahDreamAdaptedEditor";
import VDGridEditor from "./components/Dashboard/pages/VDGridEditor";
import VDStylishEditor from "./components/Dashboard/pages/VDStylishEditor";
import VDTabsEditor from "./components/Dashboard/pages/VDTabsEditor";
import VDGrid2Editor from "./components/Dashboard/pages/VDGrid2Editor";
import VDModsEditor from "./components/Dashboard/pages/VDModsEditor";
import VDPbEditor from "./components/Dashboard/pages/VDPbEditor";
import VDMomentsEditor from "./components/Dashboard/pages/VDMomentsEditor";
import VDAmbientEditor from "./components/Dashboard/pages/VDAmbientEditor";
import BuildVoyahConfig from "./components/Dashboard/pages/BuildVoyahConfig";
import VoyahFreeOrder from "./components/Dashboard/pages/VoyahFreeOrder";
import BuildDreamConfig from "./components/Dashboard/pages/BuildDreamConfig";
import VoyahDreamOrders from "./components/Dashboard/pages/VoyahDreamOrders";
import VoyahTaishanOrders from "./components/Dashboard/pages/VoyahTaishanOrders";
import FooterEditor from "./components/Dashboard/pages/FooterEditor";
import ContactSubmissionsEditor from "./components/Dashboard/pages/ContactSubmissionsEditor";
import Models from "./components/Models/Models";
import ShowRoomBaghdad from "./pages/ShowRoomBaghdad/ShowRoomBaghdad";
import ShowRoomBaghdadHeroEditor from "./components/Dashboard/pages/ShowRoomBaghdadHeroEditor";
import ShowRoomBaghdadLocationEditor from "./components/Dashboard/pages/ShowRoomBaghdadLocationEditor";
import ShowRoomBaghdadArtEditor from "./components/Dashboard/pages/ShowRoomBaghdadArtEditor";


const LogIn = lazy(() => import("./components/LogIn/LogIn"));
const Dashboard = lazy(() => import("./components/Dashboard/Dashboard"));
const NotFound = lazy(() => import("./components/NotFound/NotFound"));
const HeroSectionEditor = lazy(() => import("./components/Dashboard/pages/HeroSectionEditor"));
const ExperienceEditor = lazy(() => import("./components/Dashboard/pages/ExperienceEditor"));
const GalleryEditor = lazy(() => import("./components/Dashboard/pages/GalleryEditor"));
const VideoSectionEditor = lazy(() => import("./components/Dashboard/pages/VideoSectionEditor"));
const ServiceSupportHeroEditor = lazy(() => import("./components/Dashboard/pages/ServiceSupportHeroEditor"));
const ServiceSupportSafeEditor = lazy(() => import("./components/Dashboard/pages/ServiceSupportSafeEditor"));
const ServiceSupportAssistanceEditor = lazy(() => import("./components/Dashboard/pages/ServiceSupportAssistanceEditor"));
const ServiceSupportTTEditor = lazy(() => import("./components/Dashboard/pages/ServiceSupportTTEditor"));
const ShowRoomHeroEditor = lazy(() => import("./components/Dashboard/pages/ShowRoomHeroEditor"));
const ShowRoomLocationEditor = lazy(() => import("./components/Dashboard/pages/ShowRoomLocationEditor"));
const ShowRoomArtEditor = lazy(() => import("./components/Dashboard/pages/ShowRoomArtEditor"));
const TestDriveEditor = lazy(() => import("./components/Dashboard/pages/TestDriveEditor"));
const CampaignHeroEditor = lazy(() => import("./components/Dashboard/pages/CampaignHeroEditor"));
const CampaignsMidEditor = lazy(() => import("./components/Dashboard/pages/CampaignsMidEditor"));

const ServiceSupport = lazy(() => import("./pages/ServiceSupport/ServiceSupport"));
const ShowRoom = lazy(() => import("./pages/ShowRoom/ShowRoom"));
const TestDrive = lazy(() => import("./pages/TestDrive/TestDrive"));
const Contact = lazy(() => import("./pages/Contact/Contact"));
const Campaigns = lazy(() => import("./pages/Campaigns/Campaigns"));
const VoyahCourage = lazy(() => import("./pages/VoyahCourage/VoyahCourage"));
const VoyahFree = lazy(() => import("./pages/VoyahFree/VoyahFree"));
const VoyahDream = lazy(() => import("./pages/VoyahDream/VoyahDream"));
const VoyahTaishan = lazy(() => import("./pages/VoyahTaishan/VoyahTaishan"));
const BuildTaishan = lazy(() => import("./pages/BuildTaishan/BuildTaishan"));
const AboutUs = lazy(() => import("./pages/AboutUs/AboutUs"));
const Warranty = lazy(() => import("./pages/Warranty/Warranty"));
const RoadAssistance = lazy(() => import("./pages/RoadAssistance/RoadAssistance"));

function AppShell() {
  const location = useLocation();
  const [pageMediaReady, setPageMediaReady] = useState(false);

  useLayoutEffect(() => {
    setPageMediaReady(false);
  }, [location.key]);

  useEffect(() => {
    let cancelled = false;
    runPageMediaReadyWithCap(22000).finally(() => {
      if (!cancelled) setPageMediaReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, [location.key]);

  return (
    <>
      <MediaPageLoader show={!pageMediaReady} />
      <Suspense fallback={null}>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/voyahadmin" element={<LogIn />} />
            <Route path="/serviceSupport" element={<ServiceSupport />} />
            <Route path="/warranty" element={<Warranty />} />
            <Route path="/road-assistance" element={<RoadAssistance />} />
            <Route path="/showroom-erbil" element={<ShowRoom />} />
            <Route path="/showroom-baghdad" element={<ShowRoomBaghdad />} />
            <Route path="/testdrive" element={<TestDrive />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/voyah-courage" element={<VoyahCourage />} />
            <Route path="/voyah-free" element={<VoyahFree />} />
            <Route path="/voyah-dream" element={<VoyahDream />} />
            <Route path="/voyah-taishan" element={<VoyahTaishan />} />
            <Route path="/voyah-courage-specifications" element={<VoyahCourageSpecifications />} />
            <Route path="/voyah-free-specifications" element={<VoyahFreeSpecifications />} />
            <Route path="/voyah-dream-specifications" element={<VoyahDreamSpecifications />} />
            <Route path="/voyah-courage-build" element={<BuildCourage />} />
            <Route path="/voyah-free-build" element={<BuildVoyahFree />} />
            <Route path="/voyah-dream-build" element={<BuildVoyahDream />} />
            <Route path="/voyah-taishan-build" element={<BuildTaishan />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/models" element={<Models />} />
            <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          >
            <Route path="hero" element={<HeroSectionEditor />} />
            <Route path="experience" element={<ExperienceEditor />} />
            <Route path="gallery" element={<GalleryEditor />} />
            <Route path="videoSection" element={<VideoSectionEditor />} />
            <Route path="ssuporthero" element={<ServiceSupportHeroEditor />} />
            <Route path="ssuportsafe" element={<ServiceSupportSafeEditor />} />
            <Route path="ssuportassist" element={<ServiceSupportAssistanceEditor />} />
            <Route path="ssuportTT" element={<ServiceSupportTTEditor />} />
            <Route path="showroomhero" element={<ShowRoomHeroEditor />} />
            <Route path="showroomherolocation" element={<ShowRoomLocationEditor />} />
            <Route path="showroomheroart" element={<ShowRoomArtEditor />} />
            <Route path="showroomherobaghdad" element={<ShowRoomBaghdadHeroEditor />} />
            <Route path="showroomherolocationbaghdad" element={<ShowRoomBaghdadLocationEditor />} />
            <Route path="showroomheroartbaghdad" element={<ShowRoomBaghdadArtEditor />} />
            <Route path="testdrive" element={<TestDriveEditor />} />
            <Route path="contact-submissions" element={<ContactSubmissionsEditor />} />
            <Route path="campaignhero" element={<CampaignHeroEditor />} />
            <Route path="campaignmid" element={<CampaignsMidEditor />} />
            <Route path="courageed" element={<CourageEditor />} />
            <Route path="couragespeced" element={<CourageSpecsEditor />} />
            <Route path="couragevt" element={<CourageVideoTextEditor />} />
            <Route path="couragespcar" element={<CourageSpecCardsEditor />} />
            <Route path="couragespecsec" element={<VoyahCourageSpecSectionEditor />} />
            <Route path="courageslidered" element={<VoyahCourageSliderEditor />} />
            <Route path="courageexplore" element={<VoyahCourageExpEditor />} />
            <Route path="freehero" element={<VoyahFreeHeroEditor />} />
            <Route path="freeexp" element={<VoyahFreeExploreEditor />} />
            <Route path="freesec" element={<VoyahFreeFeelSecEditor />} />
            <Route path="freeadapt" element={<VoyahFreeAdaptedEditor />} />
            <Route path="freegrid" element={<VoyahFreeGridEditor />} />
            <Route path="freestyle" element={<VoyahStylishEditor />} />
            <Route path="freetabs" element={<VoyahFreeTabsEditor />} />
            <Route path="freetrunk" element={<VoyahFreeTrunkEditor />} />
            <Route path="freegrid2" element={<VoyahFreeGrid2Editor />} />
            <Route path="freemods" element={<VoyahFreeModsEditor />} />
            <Route path="freemome" element={<VoyahFreeMomentsEditor />} />
            <Route path="freeassist" element={<VoyahFreeAssistEditor />} />
            <Route path="freeambient" element={<VoyahFreeAmbientEditor />} />
            <Route path="vcspecifi" element={<VoyahCourageSpecificationEditor />} />
            <Route path="vfspecifi" element={<VoyahFreeSpecificationsEditor />} />
            <Route path="vdspecifi" element={<VoyahDreamSpecificationsEditor />} />
            <Route path="vdhero" element={<VoyahDreamHeroEditor />} />
            <Route path="vdexp" element={<VoyahDreamExpEditor />} />
            <Route path="vdlux" element={<VoyahDreamLuxuryEditor />} />
            <Route path="vdadapt" element={<VoyahDreamAdaptedEditor />} />
            <Route path="vdgrid" element={<VDGridEditor />} />
            <Route path="vdstylish" element={<VDStylishEditor />} />
            <Route path="vdtabs" element={<VDTabsEditor />} />
            <Route path="vdgrid2" element={<VDGrid2Editor />} />
            <Route path="vdmods" element={<VDModsEditor />} />
            <Route path="vdpb" element={<VDPbEditor />} />
            <Route path="vdmed" element={<VDMomentsEditor />} />
            <Route path="vdamb" element={<VDAmbientEditor />} />
            <Route path="bvfconf" element={<BuildVoyahConfig />} />
            <Route path="vforder" element={<VoyahFreeOrder />} />
            <Route path="bdconfig" element={<BuildDreamConfig />} />
            <Route path="vdorders" element={<VoyahDreamOrders />} />
            <Route path="vtorders" element={<VoyahTaishanOrders />} />
            <Route path="footereditor" element={<FooterEditor />} />
           
          </Route>
              
            <Route path="/notfound" element={<NotFound />} />

        </Routes>
      </Suspense>
    </>
  );
}

function App() {
  const { currentLang } = useContext(LanguageContext);

  useEffect(() => {
    document.body.classList.remove("lang-en", "lang-ar", "lang-ku");
    document.body.classList.add(`lang-${currentLang}`);
  }, [currentLang]);

  return (
    <div className="voyah">
      <Router>
        <AppShell />
      </Router>
      <ScrollToTopButton />
    </div>
  );
}

export default App;
